import { useTranslations } from 'next-intl';

import StoryRow from './_components/story-row';

// main-hero-scroll-indicator.tsx 가 이 id 로 스크롤한다 — 두 파일이 문자열을
// 각자 하드코딩하지 않도록 여기서 내보낸다.
export const MAIN_STORY_ID = 'main-story';

import story1Poster from '@images/main/main-story-1-poster.webp';
import story2Poster from '@images/main/main-story-2-poster.webp';
import story3Poster from '@images/main/main-story-3-poster.webp';

const ROWS = [
  {
    videoName: 'main-story-1-800',
    poster: story1Poster,
    reverse: false,
    floatDelay: 0,
  },
  {
    videoName: 'main-story-2-800',
    poster: story2Poster,
    reverse: true,
    floatDelay: 0.4,
  },
  {
    videoName: 'main-story-3-800',
    poster: story3Poster,
    reverse: false,
    floatDelay: 0.83,
  },
] as const;

export default function StorySection() {
  const t = useTranslations('Main.story');
  // 줄별 색 전환을 위해 번역 문구를 줄 배열로 받는다.
  const items = t.raw('items') as string[][];
  const mobileItems = t.raw('mobileItems') as string[][];

  return (
    <section
      id={MAIN_STORY_ID}
      tabIndex={-1}
      aria-label={t('label')}
      className="bg-white py-10 xl:py-0"
    >
      {ROWS.map((row, index) => (
        <StoryRow
          key={row.videoName}
          lines={items[index]}
          // 번역 배열 길이가 ROWS 와 어긋나도 데스크톱 줄 배열로 되돌아간다.
          mobileLines={mobileItems[index] ?? items[index]}
          {...row}
        />
      ))}
    </section>
  );
}
